import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { ApiUrl, SWAApiUrlProvider } from '../utilities/api-config';

@Injectable({
  providedIn: 'root',
})
export class WbidApiService {
  constructor(private http: HttpClient) {}

  /**
   * @method GetRestDataForGet get request
   * @param serviceNameandParameter (Service name and parameter as string)
   */
  public GetRestDataForGet(serviceNameandParameter: string): Observable<any> {
    return this.http.get<any>(ApiUrl + serviceNameandParameter, {
      withCredentials: true,
    });
  }
  public GetRestDataForGetSWA(serviceNameandParameter: string): Observable<any> {
    return this.http.get<any>(SWAApiUrlProvider.SWAapiUrl + serviceNameandParameter, {
      withCredentials: true,
    });
  }
  public GetRestDataForGetSWAPdf(serviceNameandParameter: string): Observable<Blob> {
    return this.http.get(SWAApiUrlProvider.SWAapiUrl  + serviceNameandParameter, {
      responseType: 'blob',
      withCredentials: true
    });
  }
 
 
  /**
   * @method GetRestDataForPost post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */

  public GetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any,
    response?: any,
  ): Observable<any> {
      if (response) {
        return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
          responseType: response,
          withCredentials: true,
        });
      } else {
        return this.http.post<any>(ApiUrl + serviceNameandParameter, jsonString, {
          withCredentials: true,
        });
      }
    
  }
   GetRestDataForPostWithProgress(serviceNameandParameter: string, jsonString: any) {
    return this.http.post(ApiUrl + serviceNameandParameter, jsonString, {
      withCredentials: true,
      reportProgress: true,
      observe: 'events'
    });
  }



  /**
   * @method AsyncGetRestDataForPost async post request
   * @param serviceNameandParameter (Service name and parameter as string)
   * @param jsonString (for passing data as string)
   */
  public async AsyncGetRestDataForPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Promise<any> {
    const rsp = await this.http
      .post<any>(ApiUrl + serviceNameandParameter, jsonString, {
        withCredentials: true,
      })
      .toPromise();
    return rsp;
  }
  public async AsyncGetRestDataForFAPost(
    serviceNameandParameter: string,
    jsonString: any
  ): Promise<any> {
    const rsp = await this.http
      .post<any>(SWAApiUrlProvider.SWAapiUrl  + serviceNameandParameter, jsonString, {
        withCredentials: true,
      })
      .toPromise();
    return rsp;
  }

}
